module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    class: [("" + (_vm.settingsObj.themeColor)), 'lighten-5'],
    attrs: {
      "id": "app",
      "standalone": ""
    }
  }, [_c('nav-drawer', {
    attrs: {
      "colors": _vm.colors,
      "animations": _vm.animations,
      "drawer": _vm.drawer,
      "settingsObj": _vm.settingsObj
    },
    on: {
      "toggleDrawer": _vm.toggleDrawer,
      "updateConfigVal": _vm.updateConfigVal,
      "startTour": function($event) {
        _vm.startTour()
      }
    }
  }), _vm._v(" "), _c('nav-bar', {
    ref: "navBar",
    attrs: {
      "settingsObj": _vm.settingsObj
    },
    on: {
      "toggleDrawer": _vm.toggleDrawer,
      "toggleInfo": _vm.toggleKey
    }
  }), _vm._v(" "), _c('main', [_c('transition', {
    attrs: {
      "name": "custom-classes-transition",
      "enter-active-class": ("animated " + (_vm.settingsObj.animation))
    }
  }, [_c('router-view', {
    ref: "currView",
    attrs: {
      "settingsObj": _vm.settingsObj,
      "drawer": _vm.drawer
    }
  })], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.settingsObj.toTop),
      expression: "settingsObj.toTop"
    }],
    class: ['top-btn', _vm.settingsObj.themeColor, 'darken-2'],
    attrs: {
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.scrollToTop($event)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_up")])], 1)], 1)], 1), _vm._v(" "), _c('v-footer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$route.fullPath.includes('Resume')),
      expression: "!$route.fullPath.includes('Resume')"
    }],
    class: ['pa-3', _vm.settingsObj.themeColor, 'darken-4', 'footer'],
    attrs: {
      "fixed": ""
    }
  }, [_c('div', {
    staticClass: "icon-holder"
  }, [_c('v-avatar', {
    class: ['icon', 'social'],
    attrs: {
      "tile": false,
      "size": "50px"
    },
    on: {
      "click": function($event) {
        _vm.openLink('https://github.com/crimsonsunset')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.iconGithub
    }
  })]), _vm._v(" "), _c('v-avatar', {
    class: ['icon', 'social'],
    attrs: {
      "tile": true,
      "size": "50px"
    },
    on: {
      "click": function($event) {
        _vm.openLink('https://www.linkedin.com/in/josephsangiorgio/')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.iconLinkedin
    }
  })])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', [_vm._v("Joe Sangiorgio © " + _vm._s(new Date().getFullYear()))])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [((_vm.showInfo == true)) ? _c('v-bottom-sheet', {
    attrs: {
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.showInfo),
      callback: function($$v) {
        _vm.showInfo = $$v
      },
      expression: "showInfo"
    }
  }, [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-list-tile', [_c('v-icon', {
    staticClass: "blue--text mr-3"
  }, [_vm._v("info\n                        ")]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    class: [((_vm.settingsObj.themeColor) + "--text"), 'darken-5']
  }, [_vm._v("Page Info: " + _vm._s(_vm.getRouteName()) + "\n                            ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(this.settingsObj.pagePrompt) + "\n                            ")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1096ead8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 454
// module chunks = 0